import { CommonModule, NgClass, NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input, 
  inject,
} from '@angular/core';
import { timer } from 'rxjs';
import { ThemeService } from '../../../_core/services/theme.service';

@Component({
  selector: 'app-int-point',
  templateUrl: './int-point.component.html',
  styleUrls: ['./int-point.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class IntPointComponent {
  private cdr = inject(ChangeDetectorRef);
  public themeService = inject(ThemeService);
  @Input({ required: true }) pointScore: number;
  @Input({ required: false }) summaryView: boolean;
}
